/**
 * Created by Simon Zhao on 7/20/21.
 * Description:
 * Define models consumed by MDL dialog component.
 *
 * ------ maintenance history ------
 *
 */

import { IMDLProvider } from '../../tamalelibs/models/template-mdl.model';
import { AdminTemplateSettingItem } from '../admin-pages/admin-page-content/admin-template-settings/admin-template-settings.model';

export class MdlDialogOpenOptions {
    minimize: boolean;
    instanceId = '';
    searchValue: string;
    isReOpen = false;
    templateItem: AdminTemplateSettingItem;
}

export class MdlFieldSection {
    fieldId: string;
    mdlProvider: IMDLProvider;
}
